/**
 * Canonical `data-cms-depth` DOM attribute values (analytics / instrumentation).
 * CMS block indices use numeric strings at render time; those stay dynamic.
 */
export enum CmsDepth {
  ExternalLink = 'external-link',
  Footer = 'footer',
  FooterSurprise = 'footer-surprise',
  Header = 'header',
  InternalLink = 'internal-link',
  LanguagePickerBackdrop = 'language-picker-backdrop',
  Modal = 'modal',
  MobileNav = 'mobile-nav',
}

/** HTML attribute name used for metrics tagging (e.g. Amplitude element hierarchy). */
export const CMS_DEPTH_ATTRIBUTE = 'data-cms-depth' as const;
